import { useState, useCallback, useEffect } from 'react';
import format from 'date-fns/format';
import { Department } from '../types';
import { handleCheckboxChange } from '../helpers';

const dayPairs = [
  { label: 'Lundi - Mardi', days: ['mon', 'tue'] },
  { label: 'Mardi - Mercredi', days: ['tue', 'wed'] },
  { label: 'Mercredi - Jeudi', days: ['wed', 'thu'] },
  { label: 'Jeudi - Vendredi', days: ['thu', 'fri'] },
  { label: 'Vendredi - Samedi', days: ['fri', 'sat'] },
];

const dayOrder = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

const SORT_BY = [
  {
    label: 'Date',
    value: 'date',
  },
  {
    label: 'Proximité',
    value: 'distance',
  },
  {
    label: 'Prix',
    value: 'price',
  },
];

const useFilters = (
  recoveryPointsStore: any,
  latitude: string,
  longitude: string,
  date: string,
  page: number,
  radius?: string,
  locationIds?: string,
) => {
  const [selectedDepartments, setSelectedDepartments] = useState<
  Record<string, boolean>
  >({});
  const [selectedPairs, setSelectedPairs] = useState<Record<string, boolean>>(
    {},
  );
  const [selectedSort, setSelectedSort] = useState(SORT_BY[0]);
  const [selectedDate, setSelectedDate] = useState(date);

  const handleDepartmentCheckboxChange = handleCheckboxChange<Department['id']>(
    setSelectedDepartments,
  );
  const handleDaysCheckboxChange = handleCheckboxChange<string>(setSelectedPairs);
  const handleSortChange = (value: string) => {
    setSelectedSort(SORT_BY.find((item) => item.value === value) || SORT_BY[0]);
  };

  const handleDateChange = (pickedDate: Date) => {
    const formattedDate = format(pickedDate, 'yyyy-MM-dd');

    setSelectedDate(formattedDate);
  };

  const getWeekdayString = useCallback(() => {
    const selectedDays = dayPairs
      .filter((pair) => selectedPairs[pair.label])
      .flatMap((pair) => pair.days);

    const uniqueDays = Array.from(new Set(selectedDays));

    const sortedDays = uniqueDays.sort(
      (a, b) => dayOrder.indexOf(a) - dayOrder.indexOf(b),
    );

    return sortedDays.length > 0 ? `${sortedDays.join(',')}` : '';
  }, [selectedPairs]);

  useEffect(() => {
    recoveryPointsStore.getPointsList({
      latitude,
      longitude,
      radius,
      date: selectedDate,
      page,
      sort: selectedSort.value,
      weekdays: getWeekdayString(),
      departmentIds: Object.keys(selectedDepartments)
        .filter((key) => selectedDepartments[key])
        .join(','),
      locationIds: locationIds || '',
    });
  }, [
    latitude,
    longitude,
    radius,
    selectedDate,
    page,
    getWeekdayString(),
    selectedPairs,
    selectedDepartments,
    selectedSort,
    locationIds,
  ]);

  return {
    selectedDepartments,
    selectedPairs,
    handleDepartmentCheckboxChange,
    handleDaysCheckboxChange,
    getWeekdayString,
    dayPairs,
    selectedSort,
    handleSortChange,
    SORT_BY,
    handleDateChange,
  };
};

export default useFilters;
